import { styled } from '@mui/material/styles';
import { Box, Drawer, List, ListItemButton, ListItemText, Stack, Typography } from '@mui/material';

export const StyledDrawer = styled(Drawer)({
  '& .MuiDrawer-paper': {
    width: 280,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  },
});

export const StyledHeaderStack = styled(Stack)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
}));

export const StyledWorkspaceStack = styled(Stack)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(1),
}));

export const StyledUserName = styled(Typography)({
  fontWeight: 'bold',
  wordBreak: 'break-word',
});

export const StyledList = styled(List)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
})) as typeof ListItemButton;

export const LogoutListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-primary': {
    color: theme.palette.error.main,
  },
}));

export const StyledUserAvatar = styled('img')({
  width: 40,
  height: 40,
  borderRadius: '50%',
  objectFit: 'cover',
});

export const StyledAvatarBox = styled(Box)({
  flexShrink: 0,
});